import { BadgeCheck, Lock, PackageCheck, Headphones } from 'lucide-react';

const ITEMS = [
  {
    Icon: BadgeCheck,
    title: 'Official SprintFit',
    detail: 'Sold only through our store',
  },
  {
    Icon: Lock,
    title: 'Secure checkout',
    detail: 'SSL-encrypted payments',
  },
  {
    Icon: PackageCheck,
    title: 'Warranty & replacement',
    detail: '1-year warranty · 7-day return',
  },
  {
    Icon: Headphones,
    title: 'Human support',
    detail: 'We reply within 1–2 business days',
  },
];

export function TrustBar({ className = '', variant = 'dark' }) {
  const isLight = variant === 'light';
  const card = isLight
    ? 'border-stone-200/90 bg-white/80 shadow-[0_1px_0_0_rgba(255,255,255,0.9)_inset]'
    : 'border-white/[0.06] bg-white/[0.02] backdrop-blur-sm';
  const titleC = isLight ? 'text-stone-800' : 'text-zinc-200';
  const detailC = isLight ? 'text-stone-500' : 'text-zinc-500';
  const iconC = isLight ? 'text-[#2c5f54]' : 'text-[#8fb8ae]';

  return (
    <div
      className={`grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 ${className}`}
      role="list"
      aria-label="Why customers can shop with confidence"
    >
      {ITEMS.map(({ Icon, title, detail }) => (
        <div
          key={title}
          role="listitem"
          className={`flex gap-3 items-start rounded-xl border p-3 sm:p-4 transition-shadow duration-300 ${card}`}
        >
          <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${iconC}`} strokeWidth={1.35} aria-hidden />
          <div className="min-w-0">
            <div className={`text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.14em] leading-tight ${titleC}`}>
              {title}
            </div>
            <div className={`text-[10px] sm:text-[11px] mt-1 leading-snug ${detailC}`}>{detail}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
